
import { client } from "../..";
import { setLoader } from "../loaderSlice";
import { SIDEMENU } from "../../databucket";
import { createAsyncThunk } from "@reduxjs/toolkit";
import { removeTypename } from "../../blueplanitUtils/removeTypename";
import {
  SINGLE_USER, UPDATE_EMPLOYEE, ADD_EMPLOYEES,
  INSERT_ATTACHMENT,
  ALL_ATTACHMENTS,
  MODIFY_ATTACHMENT_DETAILS,
} from "../../Queries/Employees"; // Your GraphQL query
import { GET_EMP_EDIT_HISTORY } from "../../Queries/Employees";
import { UPDATE_USER_ACCESS_TYPE } from "../../Queries/Users";
import {
  setUserDatas,
  setManagersDatas,
  setBankInfos,
  setClientHistorys,
  setEmploymentDatas,
  setPersonalInfos,
  setAllNotes,
  updateEditHistory,
  setWorkExperiences,
  setEmergencyContactes,
  setWorkHistorys,
  setReportsDatas,
  setEducationDatas,
  setFamilyMemberses,
  setSelectedMails,
  SideMenu,
  setFilteredLeaveData
} from "../employeeslice";
import { usersharedemaillist } from "../sharedEmailSlice";
import { message } from "antd";
export const fetchSingleUser = createAsyncThunk(
  "employee/fetchSingleUser",
  async ({ id, setImage }, { dispatch, rejectWithValue }) => {
    if (!id) return;
    dispatch(setLoader(true));
    dispatch(setUserDatas({}));
    dispatch(setManagersDatas());
    dispatch(setClientHistorys());
    dispatch(setEmploymentDatas({}));
    dispatch(setEmergencyContactes());
    dispatch(setBankInfos({}));
    dispatch(setPersonalInfos({}));
    dispatch(setWorkHistorys());
    dispatch(setReportsDatas());
    dispatch(setEducationDatas());
    dispatch(setFamilyMemberses());
    const noteFields = [
      "documentNote",
      "teamNote",
      "familyNote",
      "workNote",
      "clientNote",
      "EducationNote",
    ];

    try {
      dispatch(setLoader(true))
      const { data } = await client.query({
        query: SINGLE_USER,
        variables: { id },
        fetchPolicy: "network-only",
      });
      if (data.SingleEmployee.status !== 200)
        return;
       dispatch(FetchEditHistory({ id, page: 1 }));
      const employee = data.SingleEmployee.response;
      dispatch(
        setUserDatas({
          id: employee.id,
          EmpID: employee.EmpID,
          firstname: employee.firstname,
          lastname: employee.lastname,
          salaryCTC: employee.salaryCTC,
          dob: employee.dob || "",
          gender: employee.gender,
          currentAddress: employee.currentAddress,
          mobile: employee.mobile,
          department: employee.department,
          designation: employee.designation,
          reportingTo: employee.reportingTo,
          bloodGroup: employee.bloodGroup,
          permanentAddress: employee.permanentAddress,
          maritalStatus: employee.maritalStatus,
          processSplization: employee.processSplization,
          alternativeNumber: employee.alternativeNumber || "",
          email: employee.email || "",
          clients: employee.clients || "",
          employeestatus: employee.employeestatus || "",
          DateOfJoining: employee.DateOfJoining || "",
          personalEmail: employee.personalEmail || "",
          role: employee.role || "",
          additionalRoles: employee.additionalRoles || [],
          image: employee.image,
        })
      );

      if (setImage) setImage(employee.image);

      dispatch(setManagersDatas(employee?.teamsReportIngManager || []));

      const EmployeeMenu =
        employee?.menu && employee.menu.length > 0
          ? employee.menu
          : SIDEMENU;

      dispatch(SideMenu(EmployeeMenu));
      dispatch(setClientHistorys(employee?.client || []));

      dispatch(
        setEmploymentDatas({
          employmentStatus: employee?.employmentStatus || "",
          resignationStatus: employee?.resignationStatus || "",
          noticePeriod: employee?.noticePeriod || "",
          resignationDate: employee?.resignationDate || "",
          lastWorkingDay: employee?.lastWorkingDay || "",
          RehireEligibility: employee?.RehireEligibility || "",
        })
      );
      dispatch(
        setWorkExperiences({
shiftInTime: employee?.shiftInTime || "",
shiftOutTime: employee?.shiftOutTime || "",
          EmploymentType: employee?.EmploymentType || "",
          Experience: {
            years: employee?.Experience?.years || "",
            months: employee?.Experience?.months || "",
          },
          WorkType: employee?.WorkType || "",
          ProbationStatus: employee?.ProbationStatus || "",
          probationPeriod: employee?.probationPeriod || "",
        })
      );

      dispatch(setEmergencyContactes(employee.emergencyContacts));

      dispatch(
        setBankInfos({
          BankAccountNo: employee?.BankAccountNo || "",
          Branch: employee?.Branch || "",
          IFCcode: employee?.IFCcode || "",
          BankName: employee?.BankName || "",
          PanNumber: employee?.PanNumber || "",
        })
      );

      dispatch(
        setPersonalInfos({
          adharNumber: employee?.adharNumber || "",
          PanNumber: employee?.PanNumber || "",
          UAN: employee?.UAN || "",
          EsiNo: employee?.EsiNo || "",
          HealthInsuranceNo: employee?.HealthInsuranceNo || "",
          PfNo: employee?.PfNo || "",
        })
      );

      dispatch(setWorkHistorys(employee?.workHistory || []));
      dispatch(setReportsDatas(employee?.teamsReportDirect || []));
      dispatch(setEducationDatas(employee.education));
      dispatch(setFamilyMemberses(employee.familyMembers));
      dispatch(setSelectedMails(employee?.emailSettings || []));
      dispatch(usersharedemaillist(employee?.sharedemailSettings || []));

      noteFields.forEach((field) => {
        const NoteData = employee?.[field];
        dispatch(setAllNotes({ data: NoteData, name: field }));
      });

      const employeesLeaves = employee.leavesSettings;
      const userDepartment = employee.department;
      const currentYear = new Date().getFullYear().toString();

      const filteredLeave = employeesLeaves?.find(
        (leave) => leave.year === currentYear && leave.department === userDepartment
      );

      if (filteredLeave) {
        const { __typename, ...filteredLeaveData } = filteredLeave;
        dispatch(setFilteredLeaveData(filteredLeaveData));
      } else {
        dispatch(setFilteredLeaveData({}));
      }

      return employee;
    } catch (error) {
      message.error({
        content: "Unbelow load the data faild to fetch"
      })
      console.error("Error fetching single user:", error);
      dispatch(setLoader(false));
      return rejectWithValue(error.message || "Failed to fetch user");
    }
  }
);

export const FetchEditHistory = createAsyncThunk(
  "employee/FetchEditHistory",
  async ({ id, page }, { dispatch, rejectWithValue }) => {
    if (!id) return;
    try {
    
      const { data } = await client.query({
        query: GET_EMP_EDIT_HISTORY,
       variables: {
          empid: id,                   
          page: page?.current || 1,   
          limit: page?.pageSize || 10  
        },
        fetchPolicy: "network-only",
      });

      const history = data?.GetEditHistory || [];
    
      dispatch(updateEditHistory(history));
      return history;
    }
    catch (error) {
      console.error("Error fetching edit history:", error);
      return rejectWithValue(error.message || "Failed to fetch edit history");
    }
  }
);

export const updateEmployee = createAsyncThunk(
  "employee/updateEmployeeMenu",
  async ({ id, input }, { rejectWithValue }) => {
    try {
      const result = await client.mutate({
        mutation: UPDATE_EMPLOYEE,
        variables: {
          id,
          input: removeTypename(input),
        },
      });
      return true;
    } catch (error) {
      console.error("Error updating employee:", error.message);
      return rejectWithValue(error.message || "Update failed");
    }
  }
);

export const insertAttachmentThunk = createAsyncThunk(
  "attachment/insertAttachment",
  async ({ id, valuesObject }, { rejectWithValue }) => {
    try {

      const { data } = await client.mutate({
        mutation: INSERT_ATTACHMENT,
        variables: {
          id: id,
          data: valuesObject,
        },
      });

      return data;
    } catch (error) {
      message.error({
        content: "Unbelow Insert the data"
      })
      console.error("Error inserting attachment:", error);
      return rejectWithValue(error.message || "Failed to insert attachment");
    }
  }
);
export const fetchAllAttachments = createAsyncThunk(
  "attachments/fetchAll",
  async ({ ID }, { dispatch, rejectWithValue }) => {
    try {
      const { data } = await client.query({
        query: ALL_ATTACHMENTS,
        variables: { ID },
        fetchPolicy: "network-only",
      });
      const rawData = data?.FetchAttachments?.response?.attachemnts || [];
      const attachmentHistory = rawData.flatMap((employee) =>
        Array.isArray(employee?.attachmetHistory) ? employee.attachmetHistory : []
      );

      dispatch(setLoader(false))
      return {
        attachments: rawData,
        attachmentsHistory: attachmentHistory,
      };
    } catch (error) {
      message.error({
        content: "Unbelow load the data faild to fetch"
      })
      console.error("Fetch attachments error:", error);
      return rejectWithValue(error.message || "Failed to fetch attachments");
    } finally {
      dispatch(setLoader(false))
    }
  }
);



export const modifyAttachmentDetailsThunk = createAsyncThunk(
  "attachments/modifyAttachmentDetails",
  async ({ id, input }, { rejectWithValue }) => {
    try {
      const { data } = await client.mutate({
        mutation: MODIFY_ATTACHMENT_DETAILS,
        variables: { id, input },
      });
      return data;
    } catch (error) {
      message.error({
        content: "Unbelow update the attachment "
      })
      return rejectWithValue(error.message);
    }
  }
);
export const addEmployeeThunk = (input) => async (dispatch) => {
  try {
    const { data } = await client.mutate({
      mutation: ADD_EMPLOYEES,
      variables: { input },
    });
    dispatch({ type: 'ADD_EMPLOYEE_SUCCESS', payload: data });
    return { data };
  } catch (error) {
    dispatch({ type: 'ADD_EMPLOYEE_FAILURE', error });
    console.error('Error adding employee:', error);
    throw error;
  }
};

export const updateEmployeeAccessType = createAsyncThunk(
  "employee/updateEmployeeAccessType",
  async ({ id, accessType }, { rejectWithValue }) => {
    try {
      await client.mutate({
        mutation: UPDATE_USER_ACCESS_TYPE,
        variables: {
          id,
          accessType,
        },
      });

      return true;
    } catch (error) {
      console.error("Error updating employee access type:", error);
      return rejectWithValue(error.message || "Update failed");
    }
  }
);